export default {

	init() {
		const htmlElement = document.documentElement;
		htmlElement.classList.remove('no-js');
		htmlElement.classList.add('js');

		this.scrollbarWidth();
		this.setAllExternalLinksToOpenInNewTab();
		this.tableHelper();
	},

	scrollbarWidth() {
		let scrollbarWidth = window.innerWidth - document.body.clientWidth;
		let root = document.querySelector(':root');

		root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
	},

	getPrefersReducedMotion() {
		return window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;
	},

	getViewportWidth() {
		return Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		)
	},

	isMobile(bp = '1023px') {
		return window.matchMedia('(max-width: '+bp+')').matches;
	},

	setAllExternalLinksToOpenInNewTab() {
		const links = document.getElementsByTagName('a');
		for(var i = 0; i < links.length; i++) {
			const href = links[i].href;

			if(href.length > 5) {
				const hrefHostname = new URL(links[i].href).hostname;

				const matches = (hrefHostname == window.location.hostname || 'www.' + hrefHostname == window.location.hostname || hrefHostname == 'www.' + window.location.hostname);
				if(!matches) links[i].target = '_blank';
			}
		}
	},

	tableHelper() {
		const tables = document.getElementsByTagName('table');

		Array.from(tables).forEach(function(element, index) {
			let wrapper = document.createElement('div');
			wrapper.classList.add('table-wrap');

			element.parentNode.insertBefore(wrapper, element);
			wrapper.appendChild(element);
		});
	},

};
